import { useEffect, useRef, useState } from "react";
import { INACTIVE_TIMEOUT } from "../components/constants";

export default function useIdleMonitor(onIdle) {
    const [lastActiveTime, setLastActiveTime] = useState(() => parseInt(localStorage.getItem("lastActiveTime")) || Date.now());
    const timeoutRef = useRef(null);
    const debounceDelay = 1000;

    const handleUserActive = () => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
            setLastActiveTime(Date.now());
            localStorage.setItem("lastActiveTime", Date.now());
        }, debounceDelay);
    };

    useEffect(() => {
        const handleInactive = () => {
            if (Date.now() - lastActiveTime > INACTIVE_TIMEOUT) {
                onIdle();
            }
        };

        timeoutRef.current = setTimeout(handleInactive, INACTIVE_TIMEOUT);

        window.addEventListener("mousemove", handleUserActive);
        window.addEventListener("keydown", handleUserActive);

        return () => {
            clearTimeout(timeoutRef.current);
            window.removeEventListener("mousemove", handleUserActive);
            window.removeEventListener("keydown", handleUserActive);
        };
    }, [lastActiveTime, onIdle]);
}
